import { helpers } from '../helpers.js';
import { poi } 		from './poi.js';

var map = {
	selectors: { },

	init: function () {
		var self = this;

		self.toggleList();

		if( document.querySelectorAll( '.initmap' ).length < 1 ) {
			return false;
		}

		// self.initMap();
		self.viewDetail();

		jQuery( '.initmap__click' ).on( 'click', function( event ){
			event.preventDefault();
			
			const googleAPI = jQuery( this ).parent().parent().find( '.google-maps-api-src' );
			googleAPI.attr( 'src', googleAPI.attr( 'data-src' ) );

			// jQuery( this ).parent().addClass( 'initmap--shoud-load' );
			setTimeout(function(){
				self.initMap();
				jQuery( this ).parent().addClass( 'initmap--loaded' );
			}, 150 );
		});
		
		jQuery( '.listing-controls__toggleMap' ).on( 'click', function( event ){
			event.preventDefault();
			
			const googleAPI = jQuery( '.initmap.initmap--shoud-load' ).parent().find( '.google-maps-api-src' );
			googleAPI.attr( 'src', googleAPI.attr( 'data-src' ) );

			// jQuery( this ).parent().addClass( 'initmap--shoud-load' );
			setTimeout(function(){
				self.initMap();
				// jQuery( '.initmap.initmap--shoud-load' ).addClass( 'initmap--loaded' );
			}, 200 );
		});
	},

	toggleList: function() {
		let self = this;

		const checkbox = document.querySelector('[name="tiles-layout"]');
		const checkboxState = helpers.getCookie("list-layout-state");

		if(checkbox && checkboxState) { // Kontrola existence checkboxu a cookie
			checkbox.checked = (checkboxState === "cards");
		}

		if(checkbox) { // Kontrola existence checkboxu
			checkbox.addEventListener('change', function() {
				let state = this.checked ? "cards" : "lines"
				helpers.setCookie("list-layout-state", state, 7);
			});
		}
	},

	viewDetail: function() {
		var self = this;

		jQuery( 'body.page .block-place-map__card .button' ).on( 'click', function( e ){
			if( jQuery( this ).attr( 'href' ) == '#' ) {
				return;
			}

			window.open( jQuery( this ).attr( 'href' ), '_blank' ).focus();
		});

		jQuery( '.map-listing .block-place-map__card .button' ).on( 'click', function( e ){
			e.preventDefault();

			let post_id = jQuery( this ).closest( '[data-id]' ).attr( 'data-id' );

			self.pctApiCall( {
				action: 'get_poi_detail',
				post_id: post_id,
			}).then( response => {
	
				if( ! response.success ) {
					console.error( 'Error: ', response.data.message );
					return false;
				}

				jQuery( '.map-listing__detail' ).html( response.data.html );
				jQuery( '.map-listing__detail' ).addClass( 'active' );
				jQuery( '.switching-list' ).addClass( 'd-none' );

				var slidersToInit = jQuery('.article-gallery__inner:not(.tns-slider)');
				slidersToInit.each(function() {
					let slider = tns({
						container: this,
						items: 1,
						slideBy: 'page',
						gutter: 20,
					});
				});

				poi.loadTabEvents();
				poi.switchTab();
				poi.showMore();
	
			}).catch(error => {
				console.error( 'Error: ', error );
			});
		});
	},

	pctApiCall: function( data ) {
		return new Promise((resolve, reject) => {
			jQuery.ajax({
				type: 'POST',
				url: pctVars.ajax_url,
				dataType: 'json',
				cache: false,
				// contentType: 'application/json', 
				// data: JSON.stringify( data ),
				data: data,
				success: function( response ){
					resolve(response);
				},
				error: function( response ){
					console.log( '^^^^^^^^^^^^^^^^^' );
					console.log( response );
				},
			}).done(function(data, textStatus, jqXHR) {
				//console.log("Success: ", data);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log( '--------' );
				console.log("Error: ", jqXHR);
				console.log("Error: ", textStatus);
				console.log("Error: ", errorThrown);
			});
		});
	},

	initMap: function() {
		var self = this;

		document.querySelectorAll( '.initmap.initmap--shoud-load:not( .initmap--loaded )' ).forEach(function( map, item){
			let mapData = JSON.parse( map.getAttribute( 'data-mapdata' ) );
			const mapZoom = parseInt( map.getAttribute( 'data-zoom' ) );
			const colored = map.getAttribute( 'data-colored' );

			// Extract polygon data from the 'data-polygons' attribute
			const polygonData = JSON.parse(map.getAttribute('data-polygons') || '[]');
			let polygonCoordinates = [];

			// console.log( mapData );

			let options = {
				zoom: ( mapZoom ) ? mapZoom : 16, // Default zoom, could be adjusted based on your needs
				center: {lat: mapData[0].lat, lng: mapData[0].lng }, // Center map based on first location or specific logic

				//disableDefaultUI: true,
				streetViewControl: false, // Disable Street View
				mapTypeControl: false, // Disable Map Type Control
				fullscreenControl: false, // Disable Fullscreen Control
				// zoomControl: true, // Disable Zoom Control
				rotateControl: false, // Disable Rotate Control
				scaleControl: false, // Disable Scale Control
			};

			let styleOptions = {
				styles: [
					{
						featureType: "poi", // Target all points of interest
						stylers: [{ visibility: "off" }] // Hide them
					},
					{
						featureType: "transit", // Target all forms of transit for a cleaner map
						stylers: [{ visibility: "off" }] // Hide them
					},
					{
						featureType: "road", // Enhance or simplify roads
						elementType: "labels.icon",
						stylers: [{ visibility: "off" }] // Hide road labels/icons for a cleaner look
					},
					{
						featureType: 'road',
						elementType: 'geometry',
						stylers: [{ color: '#EFEFEF' }] // Set road color to white
					},
					{
						featureType: 'landscape',
						elementType: 'geometry',
						stylers: [{ color: '#FFFFFF' }] // Set the landscape color to black
					},
				]
			};

			if( colored == "false" ) {
				options = {
					...options,
					...styleOptions
				};
			}

			var map = new google.maps.Map( map, options );

			if (polygonData.length > 0) {
				// If polygonData is provided and has coordinates
				polygonCoordinates = polygonData.map(point => ({ lat: point.lat, lng: point.lng }));
			}

			// Create the polygon
			const polygon = new google.maps.Polygon({
				paths: polygonCoordinates,
				strokeColor: '#816826',
				strokeOpacity: 0.8,
				strokeWeight: 2,
				fillColor: '#816826',
				fillOpacity: 0.35
			});

			// Set the polygon on the map
			polygon.setMap(map);
		
			// Loop through locations to place markers
			mapData.forEach(function(location) {
				if( location.address == undefined) {
					location.address = (Math.random() + 1).toString(36).substring(7);
				}
				var marker = new google.maps.Marker({
					position: {lat: location.lat, lng: location.lng},
					map: map,
					title: location.address.trim(), // Optional: could be replaced with any other location data
					// icon: `${location.customIcon}#poid-${location.poid}`
					icon: {
						url: `${location.customIcon}#poid-${location.poid}`,
						size: new google.maps.Size(72, 82),
						origin: new google.maps.Point(0, 0),
						anchor: new google.maps.Point(36, 41)
					}
				});

				marker.set( 'data-poid', location.poid );

				if( ! location.poid ) {
					return;
				}

				// document.querySelector( `[data-poid="${location.poid}"]` ).setAttribute( 'data-title', location.address );
				setTimeout(function(){
					document.querySelector( `img[src$="#poid-${location.poid}"]` ).setAttribute( 'data-title', location.address );
				}, 100 );

				google.maps.event.addListener( marker, 'click', function() {
					self.openCard( marker[ 'data-poid' ] );

					//map.setCenter(marker.getPosition());

					var scale = Math.pow(2, map.getZoom());
					var nw = new google.maps.LatLng(
						map.getBounds().getNorthEast().lat(),
						map.getBounds().getSouthWest().lng()
					);
			
					var nwPoint = map.getProjection().fromLatLngToPoint(nw);
					var point = map.getProjection().fromLatLngToPoint(marker.getPosition());
					// Calculate the new point location with the desired offset
					var newPoint = new google.maps.Point(
						point.x, // x is unchanged because we only want to move it up
						point.y - (100 / scale) // Moving the map up by 50 pixels
					);
			
					// Convert the new point back to LatLng
					var newCenter = map.getProjection().fromPointToLatLng(newPoint);
			
					// Set the map's center to the new LatLng
					map.setCenter(newCenter);

				});
			});
		});
	},

	openCard: function( poid ) {
		// console.log( poid );

		if( ! document.querySelector( `.block-place-map__card[data-id="${poid}"]` ) ) {
			return false;
		}

		const overlay = document.querySelector( '.block-place-map__cards' );
		const card = document.querySelector( `.block-place-map__card[data-id="${poid}"]` );

		overlay.addEventListener( 'click', (e) => {
			// e.preventDefault();

			overlay.classList.add( 'd-none' );
			card.classList.add( 'd-none' );
		});

		card.querySelector( '.block-place-map__card__close' ).addEventListener( 'click', (e) => {
			e.preventDefault();

			overlay.classList.add( 'd-none' );
			card.classList.add( 'd-none' );
		});

		overlay.classList.remove( 'd-none' );

		setTimeout(()=>{
			card.classList.remove( 'd-none' );
		}, 200 );

		
	}
};

export { map };